import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_REQUIREMENT_TEMPLATES } from "../../config/connString";

const createRequirementTemplate = createAsyncThunk(
  "lab-requirements/create-requirement-template",
  async (data) => {
    try {
      const api = useAxios();

      const response = await api.post(URL_REQUIREMENT_TEMPLATES, data);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export { createRequirementTemplate };
